<template>
  <div class="blend-details" data-medusa data-medusa-animation="blend-details">
    <div
      class="blend-details__column blend-details__column--left"
      data-in-out
      data-in-out-animation="slide"
    >
      <div v-for="(detail, index) in details" :key="index" class="blend-details__row">
        <div class="blend-details__key">
          <span>{{ detail['detail-key'] }}</span>
        </div>
        <div class="blend-details__value">
          <span>{{ detail['detail-value'] }}</span>
        </div>
      </div>
    </div>
    <div
      class="blend-details__column blend-details__column--right"
      data-in-out
      data-in-out-animation="slide"
    >
      <div class="blend-details__title">
        <h2>{{ $store.state.lang === 'en' ? 'Method' : 'Metodo' }}.</h2>
      </div>
      <div class="blend-details__text" v-html="text"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlendDetails',

  props: ['data'],

  computed: {
    title() {
      return this.data.column[0].title;
    },

    text() {
      return this.data.column[0].text;
    },

    details() {
      return this.data['blend-details'];
    },
  },
};
</script>

<style lang="scss" scoped>
.blend-details {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: calc((100vw / 32) * 21);
  margin-top: calc((100vh / 18) * 4);

  @include mq($until: ipadL) {
    width: calc(100% - ((100vw / 32) * 8));
    flex-direction: column-reverse;
    margin-top: calc((100vh / 18) * 2);
  }

  &__column {
    width: calc(50% - ((100vw / 32) * 1));
    flex-basis: calc(50% - ((100vw / 32) * 1));
    color: $color-white;

    @include mq($until: ipadL) {
      width: 100%;
    }
  }

  &__row {
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
    margin: calc((100vh / 18) * 0.5) 0;
  }

  &__key {
    font-family: 'IGT Frankling Gothic';
    font-weight: bold;
    color: $color-primary;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  &__value {
    font-weight: 300;
  }

  &__title h2 {
    font-weight: 400;
    font-size: rem(150px);
    font-size: calc(150px * var(--rw));
    line-height: 1;
    margin-bottom: 40px;

    @include mq($until: ipadP) {
      font-size: rem(60px);
      font-size: calc(60px * var(--rw));
    }
  }

  &__text ::v-deep p {
    font-weight: 300;
    font-size: $font-size-text;
    font-size: rem(22px);
    font-size: calc(22px * var(--rw));
    line-height: rem(40px);
    line-height: calc(40px * var(--rw));
  }
}
</style>
